import { parseCookiesToUser } from '@quintoandar/fwp-cookie';

export const getUser = () => {
  const user = parseCookiesToUser();

  const parsedUser = { login_status: false };

  if (user) {
    return {
      ...parsedUser,
      login_status: true,
      user_id: user.id,
      userAgentId: user.agent_id,
      user_email: user.email,
    };
  }

  return parsedUser;
};
